import { containerStyle } from '../../../SignUp/styles';

export default {
  container: {
    ...containerStyle
  },
  submit: {
    textTransform: 'uppercase',
    margin: '20px 0px'
  },
  goBack: {
    textDecoration: 'none'
  }
};
